import { IExternalId } from '../../../../typings/IPrebid'
import { AgentType } from '../../../enums/AgentType'

export function getEIDs(mv_uuid?: string): Array<IExternalId> {
  const eids = window.pbjs.getUserIdsAsEids() || []
  const userIds = window.pbjs.getUserIds() || []
  if (window.$mediavine.uid2) {
    eids.unshift(new UID2Id(window.$mediavine.uid2))
  }

  if (userIds['bsw_id']) {
    eids.push(new BidswitchId(userIds['bsw_id']))
  }

  if (userIds['flocId']) {
    eids.push(new FLoCId(userIds['flocId']))
  }

  // override pubcommon id with mv_uuid
  for (const eid of eids) {
    if (mv_uuid && eid.source === 'pubcid.org' && eid.uids?.length) {
      eid.uids[0].id = mv_uuid
    }

    if (
      window.$mediavine.id5Id &&
      eid.source === 'id5-sync.com' &&
      eid.uids.length
    ) {
      eid.uids[0].id = window.$mediavine.id5Id
      eid.uids[0].ext = {
        linkType: 2
      }
    }
  }
  return eids
}
abstract class ExternalPartnerId implements IExternalId {
  source: IExternalId['source']
  uids: IExternalId['uids']

  constructor(source: IExternalId['source'], uids: IExternalId['uids']) {
    this.source = source
    this.uids = uids
  }
}

class FLoCId extends ExternalPartnerId {
  constructor(flocId: IFLoCId) {
    super('chrome.com', [
      {
        id: flocId.id,
        atype: AgentType.browserBased,
        ext: {
          ver: flocId.version
        }
      }
    ])
  }
}

export interface IFLoCId {
  id: string
  version: string
}

class UID2Id extends ExternalPartnerId {
  constructor(id: string) {
    super('uidapi.com', [
      {
        id,
        atype: AgentType.personBased,
        ext: {
          rtiPartner: 'UID2'
        }
      }
    ])
  }
}
class BidswitchId extends ExternalPartnerId {
  constructor(userId: IBidswitchUserId) {
    super('bidswitch.net', [
      {
        atype: AgentType.browserBased,
        ...userId
      }
    ])
  }
}

interface IBidswitchUserId {
  id: string
  ext: {
    fpId: string
  }
}
